import { post } from "@/util/index";
import { InitData } from "@/views/Index/Index";
import { ScenicData, LineDetail } from "@/views/Scenic/Scenic";
import { AxiosResponse } from "axios";
import { LineData } from "@/views/LineList/LineListPage";
// 初始化接口
export const initData = (): Promise<AxiosResponse<InitData[]>> =>
  post("/api/init", {});

// 景区初始化接口
export const initScenicData = (
  id: number,
  lng1: number | string,
  lat1: number | string
): Promise<AxiosResponse<ScenicData>> =>
  post("/api/scenic/selectByScenicId", { scenicId: id, lng1, lat1 });

// 获取景点下的路线
export const getLineData = (id: number): Promise<AxiosResponse<LineData[]>> =>
  post("/api/line/select", { scenicId: id });

// 根据线路id查询该线路下的所有景点
export const queryLineDetail = (
  id: number
): Promise<AxiosResponse<LineDetail>> =>
  post("/api/line/selectById", { id: id });

// 景点详情查询
export const getScenicDetail = (
  pointId: number,
  lng1: number,
  lat1: number
): Promise<AxiosResponse> =>
  post("/api/point/selectByid", {
    pointId,
    lng1,
    lat1,
  });

// 获取所有类型
export const getAllType = (id: number): Promise<AxiosResponse> =>
  post("/api/getAllType", {
    scenicId: id,
  });

// 根据类型查询id
export const getScenic = (
  pointTypeId: number,
  lng1: number,
  lat1: number
): Promise<AxiosResponse> =>
  post("/api/point/select", {
    pointTypeId,
    lng1,
    lat1,
  });
